var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.875 1.25C3.32068 1.25 1.25 3.32068 1.25 5.875C1.25 8.42932 3.32068 10.5 5.875 10.5C8.42932 10.5 10.5 8.42932 10.5 5.875C10.5 3.32068 8.42932 1.25 5.875 1.25ZM0.5 5.875C0.5 2.90647 2.90647 0.5 5.875 0.5C8.84353 0.5 11.25 2.90647 11.25 5.875C11.25 8.84353 8.84353 11.25 5.875 11.25C2.90647 11.25 0.5 8.84353 0.5 5.875ZM5.875 5.5C6.08211 5.5 6.25 5.66789 6.25 5.875V7.875C6.25 8.08211 6.08211 8.25 5.875 8.25C5.66789 8.25 5.5 8.08211 5.5 7.875V5.875C5.5 5.66789 5.66789 5.5 5.875 5.5ZM5.875 3.5C5.66789 3.5 5.5 3.66789 5.5 3.875C5.5 4.08211 5.66789 4.25 5.875 4.25H5.88C6.08711 4.25 6.255 4.08211 6.255 3.875C6.255 3.66789 6.08711 3.5 5.88 3.5H5.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnInfoWhite);
export default __webpack_public_path__ + "static/media/atm-icn-info-white.bf867284d59ac3831946fa5b3abc063d.svg";
export { ForwardRef as ReactComponent };